"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureExpProjectAccessRightsPropsSchema = exports.FeatureExpProjectAccessRightsSchema = void 0;
const zod_1 = require("zod");
const AccessRoleSchema = zod_1.z.enum(['VIEWER', 'CREATOR', 'USER', 'ADMIN']);
const AccessRightItemSchema = zod_1.z.object({
    environment_id: zod_1.z.string(),
    role: AccessRoleSchema,
});
const UserAccessRightSchema = zod_1.z.object({
    id: zod_1.z.string(),
    access: zod_1.z.array(AccessRightItemSchema),
});
const TeamAccessRightSchema = zod_1.z.object({
    id: zod_1.z.string(),
    access: zod_1.z.array(AccessRightItemSchema),
});
exports.FeatureExpProjectAccessRightsSchema = zod_1.z.object({
    users: zod_1.z.array(UserAccessRightSchema).optional(),
    teams: zod_1.z.array(TeamAccessRightSchema).optional(),
});
exports.FeatureExpProjectAccessRightsPropsSchema = zod_1.z.object({
    accountId: zod_1.z.string(),
    projectId: zod_1.z.string(),
    payload: exports.FeatureExpProjectAccessRightsSchema,
});
//# sourceMappingURL=schemas.js.map